import { getNavTiersForRole } from '@cnapse/shared';
import type { NavigationItem } from '../context/AppContext';
type NavItemInput = Pick<NavigationItem, 'roles' | 'requiredRoute'>;

/** Mirrors InsightApp navigation gating (role tiers + optional route capability). */
export function canShowNavigationItem(
  userRole: string,
  item: NavItemInput,
  isRouteEnabled: (routeKey: string) => boolean,
): boolean {
  const allowedRoles = getNavTiersForRole(userRole);
  const hasRolePermission = item.roles.some((role) => allowedRoles.includes(role));
  if (!hasRolePermission) {
    return false;
  }

  if (userRole.startsWith('provider_')) {
    return true;
  }

  if (item.requiredRoute) {
    return isRouteEnabled(item.requiredRoute);
  }

  return true;
}
